import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import { 
  AppBar, Button, Card, Container, Dialog, DialogContent, DialogTitle, 
  IconButton, Paper, TextField, Tab as MuiTab, Tabs as MuiTabs
} from '@mui/material';

// Typography
export const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #333;
`;

export const ProductTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const ProductDescription = styled.p`
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

export const Price = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: #4a7061;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  
  .original-price {
    text-decoration: line-through;
    color: #999;
    font-size: 1.2rem;
    margin-left: 10px;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  
  img {
    height: 40px;
   
  }
  
  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #4a7061;
    margin: 0;
  }
`;

// Layout components
export const StyledAppBar = muiStyled(AppBar)`
  background: rgba(226, 213, 196, 0.78);
  backdrop-filter: blur(14px);
  color: #2b2a27;
  box-shadow: 0 8px 24px rgba(58, 48, 38, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.55);
  transition: background 320ms ease, box-shadow 320ms ease;
`;

export const MainContainer = muiStyled(Container)`
  padding-top: 2rem;
  padding-bottom: 4rem;
`;

export const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin-top: 2rem;
  
  @media (min-width: 960px) {
    flex-direction: row;
  }
`;

export const ProductImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  
  img {
    max-width: 100%;
    max-height: 500px;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }
`;

export const ProductDetailsContainer = styled.div`
  flex: 1;
`;

// UI Elements
export const StyledCard = muiStyled(Card)`
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
`;

export const StyledPaper = muiStyled(Paper)`
  padding: 2rem;
  margin-bottom: 2rem;
  background-color: rgba(255, 255, 255, 0.9);
`;

export const StyledButton = muiStyled(Button)`
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
`;

export const StyledTextField = muiStyled(TextField)`
  margin-bottom: 1.5rem;
  
  .MuiOutlinedInput-root {
    &:hover fieldset {
      border-color: #4a7061;
    }
    &.Mui-focused fieldset {
      border-color: #4a7061;
    }
  }
  
  .MuiInputLabel-root.Mui-focused {
    color: #4a7061;
  }
`;

export const QuantitySelector = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  
  button {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e2d5c4;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1.2rem;
    color: #4a7061;
    
    &:hover {
      background-color: #c3b5a3;
    }
  }
  
  span {
    width: 50px;
    text-align: center;
    font-size: 1.1rem;
  }
`;

export const StyledDialog = muiStyled(Dialog)`
  .MuiDialog-paper {
    padding: 1rem;
    background-color: #f8f5f2;
  }
`;

export const StyledDialogTitle = muiStyled(DialogTitle)`
  text-align: center;
  color: #4a7061;
  font-weight: 600;
`;

export const StyledDialogContent = muiStyled(DialogContent)`
  padding: 1.5rem;
`;

export const StyledIconButton = muiStyled(IconButton)`
  color: #4a7061;
`;

export const StyledTabs = muiStyled(MuiTabs)`
  margin-bottom: 1.5rem;
  
  .MuiTabs-indicator {
    background-color: #4a7061;
  }
`;

export const StyledTab = muiStyled(MuiTab)`
  color: #666;
  
  &.Mui-selected {
    color: #4a7061;
    font-weight: 600;
  }
`;

export const StyledForm = styled.form`
  width: 100%;
`;

export const DiscountBadge = styled.div`
  background-color: #4a7061;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 600;
  display: inline-block;
  margin-left: 1rem;
`;

export const HeroSection = styled.div`
  background: linear-gradient(135deg, #e2d5c4 0%, #f8f5f2 100%);
  padding: 4rem 0;
  margin-bottom: 2rem;
  
  h1 {
    font-size: 3rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 1rem;
  }
  
  p {
    font-size: 1.2rem;
    color: #666;
    max-width: 600px;
    margin-bottom: 2rem;
  }
  
  img {
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.1);
  }
`;
